import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'

import { Link } from 'react-router-dom'
import { useAppSelector } from '../redux/hooks'

export const Home = () => {

    const auth = useAppSelector(state => state.auth)
    const isSignedIn = !auth.pending && auth.data != null

    return (
        <Box sx={{ height: '100%' }}>
            <Container maxWidth="sm" sx={{ py: 2 }}>
                <Typography component="h1" variant="h2" align="center" color="text.primary" gutterBottom>
                    MVC Games
                </Typography>
                <Typography variant="h5" align="center" color="text.secondary" paragraph>
                    Experience the thrill of Missouri Valley Conference games like never before. Join bracket challenges, make
                    your picks, and compete with friends!
                </Typography>
                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                    <Link to={isSignedIn ? '/leagues' : '/auth/sign-in'}>
                        <Button variant="contained" size="large" color="primary">
                            Get Started
                        </Button>
                    </Link>
                </Box>
            </Container>
            <Container sx={{ py: 8 }} maxWidth="md">
                <Grid container spacing={4}>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <CardMedia
                                component="div"
                                sx={{
                                    pt: '56.25%',
                                    backgroundPosition: 'top'
                                }}
                                image="/img/generic-tipoff.webp"
                            />
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    Bracket Challenges
                                </Typography>
                                <Typography>Create and join exciting bracket pool challenges for Arch Madness.</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <CardMedia
                                component="div"
                                sx={{
                                    pt: '56.25%',
                                }}
                                image="/img/ball-through-hoop.jpg"
                            />
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    Live Game Tracking
                                </Typography>
                                <Typography>
                                    Follow Missouri Valley Conference games in real-time with live updates and stats.
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <CardMedia
                                component="div"
                                sx={{
                                    pt: '56.25%',
                                }}
                                image="/img/generic-crowd.webp"
                            />
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    Pick'em Challenges
                                </Typography>
                                <Typography>Test your prediction skills with our weekly pick'em challenges.</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
            <Box
                sx={{
                    bgcolor: 'background.paper',
                    pt: 8,
                    pb: 6,
                }}
            >
                <Container maxWidth="sm">
                    <Typography component="h2" variant="h3" align="center" color="text.primary" gutterBottom>
                        Ready to Join the Game?
                    </Typography>
                    <Typography variant="h5" align="center" color="text.secondary" paragraph>
                        Sign up now and start your MVC Games journey today!
                    </Typography>
                    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                        {
                            !isSignedIn && (
                                <Link to="/auth/sign-in">
                                    <Button variant="contained" size="large" color="primary">
                                        Sign Up Now
                                    </Button>
                                </Link>
                            )
                        }
                    </Box>
                </Container>
            </Box>
            <Box
                component="footer"
                sx={{
                    py: 3,
                    px: 2,
                    mt: 'auto',
                    backgroundColor: (theme) =>
                        theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
                }}
            >
                <Container maxWidth="lg">
                    <Grid container spacing={4} justifyContent="space-evenly">
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <Typography variant="h6" color="text.primary" gutterBottom>
                                About Us
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                MVC Games is your ultimate platform for Missouri Valley Conference sports engagement.
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <Typography variant="h6" color="text.primary" gutterBottom>
                                Contact Us
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Email: graham@matthewsapps.com
                            </Typography>
                            <Box sx={{ mt: 2 }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    href="https://www.buymeacoffee.com/graham7"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    ☕ Buy Me a Coffee
                                </Button>
                            </Box>
                        </Grid>
                        {/* <Grid size={{ xs: 12, sm: 4 }}>
                                <Typography variant="h6" color="text.primary" gutterBottom>
                                    Follow Us
                                </Typography>
                                <IconButton aria-label="Facebook" color="primary">
                                    <FacebookIcon />
                                </IconButton>
                                <IconButton aria-label="Twitter" color="primary">
                                    <TwitterIcon />
                                </IconButton>
                                <IconButton aria-label="Instagram" color="primary">
                                    <InstagramIcon />
                                </IconButton>
                            </Grid> */}
                    </Grid>
                    {/* <Box mt={5}>
                        <Typography variant="body2" color="text.secondary" align="center">
                            {"Copyright © "}
                            MVC Games {new Date().getFullYear()}
                            {"."}
                        </Typography>
                    </Box> */}
                </Container>
            </Box>
        </Box>
    )
}